<template>
  <div>
    <div
      v-if="isInSchedule"
      class="video-wrapper"
    >
      <!-- Video -->
      <video
        ref="posonVideo"
        class="video-bg"
        autoplay
        muted
        loop
        playsinline
        disablepictureinpicture
        @canplaythrough="handleVideoLoad"
      >
        <source
          src="@/assets/videos/posonbanner.mp4"
          type="video/mp4"
        >
      </video>

      <!-- Left centered image -->
      <img
        v-if="videoLoaded"
        class="left-image"
        src="@/assets/images/pages/poson.png"
      >
      <img
        v-if="videoLoaded"
        class="left-image2"
        src="@/assets/images/pages/happyposonday.png"
      >
    </div>
    <div v-else>
      <div
        v-if="!isRoyalTenant"
        class="greeting-page"
      >
        <div class="greeting-section">
          <h1>Good {{ greeting }}!</h1>
          <p>Hello {{ currentUser ? currentUser.first_name : '' }}, Welcome Back</p>
        </div>
        <div class="image-section">
          <div class="shape shape-top" />
          <img
            src="@/assets/images/pages/welcome.svg"
            alt="Delivery Illustration"
            class="illustration"
          >
          <div class="shape shape-bottom" />
          <div class="welcome-footer">
            Powered by CURFOX Delivery Management
          </div>
        </div>
      </div>
      <div v-else>
        <div class="banner-container">
          <!-- Main Banner Background Image -->
          <img
            src="@/assets/images/new-banner/banner-frame.png"
            alt="Banner Background"
            class="banner-image full-width"
          >

          <!-- Overlay Background with Gradient and Shape -->
          <img
            src="@/assets/images/new-banner/overlay-background.png"
            alt="Overlay Background"
            class="overlay-bg"
          >

          <!-- City Silhouette Backgrounds -->
          <img
            src="@/assets/images/new-banner/city-silhouette-1.png"
            alt="City Silhouette 1"
            class="city-silhouette-1"
          >
          <img
            src="@/assets/images/new-banner/city-silhouette-2.png"
            alt="City Silhouette 2"
            class="city-silhouette-2"
          >

          <!-- Lightning Effect Image -->
          <img
            src="@/assets/images/new-banner/lightning-effect.png"
            alt="Lightning Effect"
            class="lightning-effect"
          >

          <!-- Text Content -->
          <div class="banner-content">
            <h1 class="greeting">
              Good <span class="greeting-text">{{ greeting }}!</span>
            </h1>
            <p class="welcome-message">
              Welcome to Royal Express Courier & Logistics (Pvt) Ltd
            </p>
            <div class="powered-by">
              <div class="powered-by-text">
                Powered by <span class="powered-by-curfox">CURFOX</span> Delivery Management
              </div>
            </div>

            <div class="delivery-section">
              <p class="section-title left-title">
                Some Deliver Like This...
              </p>
              <p class="section-title right-title">
                <span class="right-fast">Fast</span> Delivery
              </p>
            </div>

            <div class="slogan-section">
              <p class="slogan">
                Choose <span class="speed">Speed.</span> Choose <span class="smart-delivery">Smart Delivery.</span>
              </p>
              <p class="company-name">
                Royal <span class="express">Express</span>
              </p>
            </div>
          </div>

          <!-- Character Images -->
          <img
            src="@/assets/images/new-banner/sloth-delivery.png"
            alt="Sloth Delivery"
            class="char-sloth"
          >
          <img
            src="@/assets/images/new-banner/sad-man.png"
            alt="Sad Man"
            class="char-sad-man"
          >
          <img
            src="@/assets/images/new-banner/fast-delivery-man.png"
            alt="Fast Delivery Man"
            class="char-fast-delivery-man"
          >
          <img
            src="@/assets/images/new-banner/happy-customer.png"
            alt="Happy Customer"
            class="char-happy-customer"
          >
        </div>
        <b-row class="mt-2 info-card-container">
          <b-col
            xl="2"
            cols="5"
            class="d-flex align-items-center justify-content-start info-card"
          >
            <feather-icon
              icon="PhoneIcon"
              size="24"
              class="info-card-icon"
            />
            <div>
              <div class="info-card-title">
                Hotline:
              </div>
              <div class="info-card-text">
                011 2 417 417
              </div>
            </div>
          </b-col>
          <b-col
            xl="3"
            cols="5"
            class="d-flex align-items-center justify-content-start info-card"
          >
            <feather-icon
              icon="SmartphoneIcon"
              size="24"
              class="info-card-icon"
            />
            <div>
              <div class="info-card-title">
                Mobile:
              </div>
              <div class="info-card-text">
                074 391 5480 / 074 391 5460
              </div>
            </div>
          </b-col>
          <b-col
            xl="3"
            cols="5"
            class="d-flex align-items-center justify-content-start info-card"
          >
            <feather-icon
              icon="GlobeIcon"
              size="24"
              class="info-card-icon"
            />
            <div>
              <div class="info-card-title">
                Web:
              </div>
              <div class="info-card-text">
                www.royalexpress.lk
              </div>
            </div>
          </b-col>
          <b-col
            xl="3"
            cols="5"
            class="d-flex align-items-center justify-content-start info-card"
          >
            <feather-icon
              icon="MailIcon"
              size="24"
              class="info-card-icon"
            />
            <div>
              <div class="info-card-title">
                Email:
              </div>
              <div class="info-card-text">
                marketing@royalexpress.lk
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>

</template>

<script>
import {
  mapGetters,
} from 'vuex'
import {
  BRow, BCol,
} from 'bootstrap-vue'
import { tenant } from '@/constants/config'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      greeting: this.getGreeting(),
      tenant,
      form: {},
      now: new Date(),
      timer: null,
      startTime: new Date('2026-06-29T00:00:00+05:30'),
      endTime: new Date('2026-06-30T00:00:00+05:30'),
      videoLoaded: false,
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    isRoyalTenant() {
      return this.tenant === 'royalexpress'
    },
    isInSchedule() {
      return this.now >= this.startTime && this.now <= this.endTime
    },
  },
  mounted() {
    this.form = JSON.parse(localStorage.getItem('businessSettings'))
    this.timer = setInterval(() => {
      this.now = new Date()
    }, 1000)
    if (this.$refs.posonVideo && this.$refs.posonVideo.readyState >= 4) {
      this.videoLoaded = true
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    getGreeting() {
      const currentHour = new Date().getHours()
      if (currentHour >= 5 && currentHour < 12) {
        return 'Morning'
      } if (currentHour >= 12 && currentHour < 18) {
        return 'Afternoon'
      }
      return 'Evening'
    },
    handleVideoLoad() {
      this.videoLoaded = true
    },
  },
}
</script>

<style scoped>
/* Import Fonts (You can also move this to your index.html) */
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&family=Montserrat:wght@300;400&display=swap');

.festive-container {
  position: relative;
  width: 100%;
  height: 650px; /* Adjust height as needed */
  background: linear-gradient(to bottom, #532540, #FD326C);
  overflow: hidden;
  font-family: 'Montserrat', sans-serif;
  color: white;
  border-radius: 5px;
}

/* --- Background Stars (Simulated with CSS) --- */
.star-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Settings for the snow image */
  background-repeat: repeat;
  background-position: center top;
  background-size: cover; /* Ensures it covers the area */
  opacity: 0.8; /* Adjust based on how bright your snow png is */
  pointer-events: none;
}

/* --- Text Styling --- */
.text-content {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 50px 80px 0 80px;
}

.main-title {
  font-family: 'Great Vibes', cursive; /* Script font */
  font-size: 3.2rem;
  font-weight: 400;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  letter-spacing: 1px;
  color:#ffffff;
}

.sub-title {
  font-family: 'Montserrat', sans-serif;
  font-size: 1.1rem;
  font-weight: 400;
  margin-top: 5px;
  opacity: 0.9;
  letter-spacing: 0.5px;
}

/* --- Bells Styling --- */
.bells-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 20;
}

.bells-img {
  width: 150px; /* Adjust based on your image size */
  height: auto;
  filter: drop-shadow(0 5px 10px rgba(0,0,0,0.3));
}

/* --- The Curved Background Layers --- */
.curves-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

/* The Pink Band */
.curve-pink {
  position: absolute;
  bottom: -60%; /* Pushes the circle down to create the arch */
  left: -10%;
  width: 120%;
  height: 120%;
  background: #E03064; /* Pink color */
  border-radius: 50%; /* Creates the curve */
}

.curve-light-pink {
  position: absolute;
  bottom: -65%; /* Pushes the circle down to create the arch */
  left: -10%;
  width: 120%;
  height: 120%;
  background: #FFC0D3; /* Pink color */
  border-radius: 50%; /* Creates the curve */
}

/* The White Area */
.curve-white {
  position: absolute;
  bottom: -70%;
  left: -10%;
  width: 120%;
  height: 120%;
  background: #ffffff;
  border-radius: 50%;
}

/* --- Santa Center Image --- */
.santa-container {
  position: absolute;
  bottom: 15%; /* Adjust to overlap the curve correctly */
  left: 50%;
  transform: translateX(-50%);
  z-index: 30;
  display: flex;
  justify-content: center;
}

.santa-img {
  width: 380px; /* Adjust based on your Santa image size */
  height: auto;
  filter: drop-shadow(0 10px 20px rgba(0,0,0,0.2));
}

.video-wrapper {
  width: 100%;
  display: flex;
  position: relative;
}

.video-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.left-image {
  position: absolute;
  left: 30%;
  top: 35%;
  transform: translateY(-50%);
  width: 40%;
  z-index: 2;
}

.left-image2 {
  position: absolute;
  left: 37.5%;
  top: 42%;
  transform: translateY(-50%);
  width: 25%;
  z-index: 2;
}

/* --- Responsive Adjustments --- */
@media (max-width: 768px) {
  .festive-container {
    height: 500px;
  }

  .main-title {
    font-size: 1.8rem;
  }

  .sub-title {
    font-size: 0.8rem;
  }

  .bells-img {
    width: 100px;
  }

  .santa-img {
    width: 280px;
  }

  .text-content {
    padding: 50px 70px 0 70px;
  }
}
.greeting-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f8fa;
  box-sizing: border-box;
  overflow: hidden; /* Prevent scrolling */
}

.greeting-section {
  flex: 1;
  margin-left: 5%;
}

.greeting-section h1 {
  font-size: 2.5em;
  margin: 0;
  color: #333;
}

.greeting-section p {
  font-size: 1.2em;
  color: #777;
  margin-top: 10px;
  font-weight: 500;
}

.image-section {
  flex: 1;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100%; /* Ensures it adjusts to the height of the container */
}

.illustration {
  max-width: 100%;
  max-height: 100%; /* Ensure it scales down if needed */
  z-index: 2;
  padding-right: 5%;
}

.shape {
  position: absolute;
  background-color: #3498db;
  border-radius: 50%;
  opacity: 0.3;
}

.shape-top {
  width: 50vw;
  height: 50vw;
  top: -35vh;
  left: -30vw;
  z-index: 1;
  transform: translate(-50%, -50%);
}

.shape-bottom {
  width: 50vw;
  height: 50vw;
  top: 5vh;
  left: -15vw;
  z-index: 1;
  transform: translate(-50%, 50%);
}

.welcome-footer {
  text-align: right;
  font-size: 0.9em;
  color: #000000;
  width: 100%;
  font-weight: 500;
  padding: 20px;
}
@media (max-width: 768px) {
  .greeting-page {
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }

  .greeting-section {
    margin-left: 0;
    text-align: center;
    margin-bottom: 20px;
  }

  .greeting-section h1 {
    font-size: 1.8em;
  }

  .greeting-section p {
    font-size: 1em;
  }

  .image-section {
    padding: 0 10px;
  }

  .illustration {
    max-width: 100%;
    max-height: auto;
    padding-right: 0;
  }

  .shape-top {
    width: 40vw;
    height: 40vw;
    top: -5vh;
    left: -10vw;
  }

  .shape-bottom {
    width: 40vw;
    height: 40vw;
    bottom: 0vh;
    left: 0vw;
    transform: translate(200%, 60%);
  }

  .welcome-footer {
    text-align: center;
    font-size: 0.8em;
    padding: 10px;
  }
}
</style>
<style lang="scss" scoped>
  .banner-container {
    position: relative;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    padding-bottom:40%; /* Adjusted: e.g., for a 1200x324 banner aspect ratio */
    background-color: #fcf8f3; /* A soft background color to fill empty space */
    border-radius: 15px; /* Matches your banner frame */
  }

  /* Base styles for all images, we'll override for specific ones */
  .banner-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* Default to cover for backgrounds, will be overridden for characters */
    object-fit: cover;
    pointer-events: none; /* Prevents images from interfering with text selection/interaction */
  }

  /* Specific image positioning and sizing */
  /* The main frame image */
  .full-width {
    object-fit: fill; /* Use 'fill' to ensure the frame itself stretches to fill the container */
    z-index: 1; /* Lowest layer */
    border-radius: 15px; /* Inherit or explicitly set border-radius */
  }

  /* The light beige rounded rectangle */
  .overlay-bg {
    position: absolute;
    z-index: 2;
    width: 40%; /* Example: adjust width */
    left: 50%;
    transform: translateX(-50%); /* Center it */
    top: 3%; /* Adjust vertical position */
    height: 40%; /* Give it a specific height */
    object-fit: fill; /* Contain for the silhouette itself */
    opacity: 0.8; /* Make it slightly transparent */
  }

  .city-silhouette-1 {
    position: absolute;
    z-index: 3;
    /* This image is probably the exact size of the content area within the frame */
    /* You'll need to adjust its position and size relative to the frame */
    top: 34%; /* Example adjustment */
    left: 2%; /* Example adjustment */
    width: 38%; /* Example adjustment */
    height: 59.8%; /* Example adjustment */
  }

  .city-silhouette-2 {
    position: absolute;
    z-index: 3;
    width: 60%; /* Broader city for the left side */
    left: 38%;
    top: 25.8%;
    height: 68%; /* Adjust height */
  }

  .lightning-effect {
    position: absolute;
    z-index: 5;
    width: 20%; /* Adjust size */
    left: 40%;
    top: 26%;
    height: 60%; /* Give it a height */
  }

  /* Character Images - Use 'contain' for these */
  .char-sloth {
    position: absolute;
    z-index: 6;
    width: 15%; /* Adjust size relative to banner */
    left: 4%;
    bottom: 10%;
    object-fit: contain;
    height: 35%; /* Let height adjust proportionally */
  }

  .char-sad-man {
    position: absolute;
    z-index: 6;
    width: 10%;
    left: 18%;
    bottom: 10%;
    object-fit: contain;
    height: 40%;
  }

  .char-fast-delivery-man {
    position: absolute;
    z-index: 7;
    width: 25%;
    right: 20%;
    bottom: 20%;
    object-fit: contain;
    height: 45%;
  }

  .char-happy-customer {
    position: absolute;
    z-index: 6;
    width: 20%;
    right: 3%;
    bottom: 25%;
    object-fit: contain;
    height: 40%;
  }

  /* Text Content Positioning */
  .banner-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: #333; /* Default text color */
    font-family: 'Montserrat', sans-serif; /* A modern font, add to your index.html or global styles */
  }

  .greeting {
    position: absolute;
    top: 10%;
    left: 5%;
    z-index: 3;
    font-size: 2rem;
    font-weight: bold;
    color: #240046; /* Darker color for "Good" */
  }

  .greeting-text {
    color: #FF6C1E;
  }

  .welcome-message {
    position: absolute;
    top: 19%;
    left: 5%;
    z-index: 3;
    font-size: 1rem;
    color: #333958;
  }

  .powered-by {
    position: absolute;
    top: 26%;
    left: 2.7%;
    z-index: 3;
    background-color: rgba(253, 246, 237, 0.7);
    border-radius: 0 15px 15px 0;
  }

  .powered-by-text {
    font-size: 0.8rem;
    color: #240046A8;
    padding: 0.3rem 2rem;
    white-space: nowrap; /* Prevent text wrapping */
  }

  .powered-by-curfox {
    font-weight: bold;
  }

  .section-title {
    font-size: 1.2rem;
    font-weight: bold;
  }

  .left-title {
    position: absolute;
    top: 40%; /* Adjust this based on where the horizontal separator line is visually */
    left: 5%;
    z-index: 3;
    color: #240046;
  }

  .right-title {
    position: absolute;
    top: 30%; /* Adjust this based on where the horizontal separator line is visually */
    right: 18%;
    z-index: 3;
    color: #D16A37;
    margin-bottom: 10px;
  }

  .right-fast {
    color: #240046;
  }

  .slogan-section {
    position: absolute;
    bottom: 5%;
    right: 3%;
    z-index: 3;
    text-align: right;
    margin-bottom: 10px;
  }

  .slogan {
    font-size: 1rem;
    font-weight: 500;
    color: #240046;
    line-height: 0.5 !important;
  }

  .slogan .speed {
    color: #D16A37;
  }

  .slogan .smart-delivery {
    color: #D16A37; /* Purple color */
  }

  .company-name {
    font-size: 1.2rem;
    font-weight: bold;
    color: #240046;
    line-height: 0 !important;
  }

  .express {
    color: #D16A37;
  }

  .info-card-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }

  .info-card {
    background-color: #F2E6CC;
    border-radius: 10px;
    padding: 10px;
    margin-top: 10px;
  }

  .info-card-icon {
    color: #F5895B;
    margin-right: 10px;
  }

  .info-card-title {
    font-weight: bolder;
  }

  .info-card-text {
    white-space: normal; /* Allow text to wrap to the next line */
    word-break: break-word; /* Ensure long words/numbers break if they exceed container width */
    font-weight: 500;
  }

  @media (max-width: 648px) {
    .banner-container {
      padding-bottom:80%;
    }
    .greeting {
      font-size: 1rem;
      top: 8%;
    }
    .welcome-message {
      font-size: 0.6rem;
      top: 13%;
    }
    .powered-by {
      top: 20%;
    }
    .powered-by-text {
      font-size: 0.5rem;
      padding: 0.1rem 0.6rem;
    }
    .section-title {
      font-size: 0.7rem;
      font-weight: bold;
    }
    .right-title {
      top: 28%;
    }
    .slogan-section {
      margin-bottom: 0;
    }
    .slogan {
      font-size: 0.5rem;
    }
    .company-name {
      font-size: 0.7rem;
    }
    .info-card-title {
      font-size: 0.5rem;
    }
    .info-card-text {
      font-size: 0.5rem;
    }
    .info-card-icon {
      width: 16px; /* Reduce icon width */
      height: 16px; /* Reduce icon height */
    }
  }

  @media (max-width: 950px) {
    .slogan-section {
      bottom: 3%;
    }
  }

  @media (min-width: 648px) and (max-width: 950px) {
    .banner-container {
      padding-bottom:60%;
    }
    .powered-by-text {
      padding: 0.3rem 1.2rem;
    }
  }
</style>
